import { useState, useEffect } from "react";
import CryptoJS from "crypto-js";

export function useBrowserFingerprint() {
    const [ip, setIp] = useState('');

    useEffect(() => {
        fetch("https://api.ipify.org?format=json") // Ensures IPv4
            .then((response) => response.json())
            .then((data) => {
                const encryptedFingerprint = CryptoJS.AES.encrypt(data.ip, process.env.REACT_APP_PINGERPRINT_KEY)?.toString();
                setIp(encryptedFingerprint)
            })
            .catch((error) => console.error("Error fetching IP:", error));
    }, []);


    return ip;
}